import { PageHeader } from './page-header.tsx' 
import { BreadcrumbItem, BreadcrumbNav } from './breadcrumb-nav' 

interface BasePageProps {
    title?: string
    description?: string
    children?: React.ReactNode
    breadcrumbs?: BreadcrumbItem[]
}

export function BasePage({ title, description, children, breadcrumbs }: BasePageProps) {
    return (
        <div className="container mx-auto px-4 py-8 overflow-hidden">
            {breadcrumbs ? (
                <BreadcrumbNav items={breadcrumbs} />
            ) : title ? (
                <PageHeader title={title} description={description} />
            ) : null}
            <div>{children}</div>
        </div>
    )
} 